
export const LOCATION = 'LOCATION'
export const FETCH_LOADING = 'FETCH_LOADING'
export const HOTELSTORE = 'HOTELSTORE'
export const DEFAULTDATE = 'DEFAULTDATE'
export const BRANDLIST = 'BRANDLIST'
export const HOTELDETAIL = 'HOTELDETAIL'
export const SCROLLTOP = 'SCROLLTOP'
export const BMAPLOCATION = 'BMAPLOCATION'
export const ROOMNUMBER = 'ROOMNUMBER'
export const COVER = 'COVER'
export const VALIDATEFORM = 'VALIDATEFORM'
export const KEYS = 'KEYS'


// WEBPACK FOOTER //
// ./src/store/mutations-type.js